// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__Y0yAw","icon":"NavLink_icon__rkv54","active":"NavLink_active__OAqqR","counter":"NavLink_counter__EzzAV"};